import { ReactNode, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import Scroll from 'react-scroll';

import { useHolidaysNotifications } from '~/root/Holidays';
import { getCanonicalHref } from '~/utils/canonicalHref';
import { Header } from './Header';

export const InnerLayout = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  useHolidaysNotifications();

  useEffect(() => {
    Scroll.animateScroll.scrollToTop({
      duration: 0,
    });
  }, [location.pathname]);

  const canonicalHref = getCanonicalHref();

  return (
    <div className="relative flex flex-col  min-h-screen">
      <Helmet>
        <link rel="canonical" href={canonicalHref} />
      </Helmet>
      <Header />
      {children}
    </div>
  );
};
